// extracted by mini-css-extract-plugin
module.exports = {"secondary":"zero_decision_results_buttons-module__secondary--EQGQb"};